<template>
  <transition
    name="sunrise"
    appear
  >
    <slot
      name="content"
    />
  </transition>
</template>

<script>
export default {
  name: 'OwalTransitionSunrise',
}
</script>

<style scoped>
.sunrise-enter-active {
  animation-name: sunrise;
  animation-duration: 800ms;
  animation-timing-function: ease-out;
}

.sunrise-leave-active, .sunrise-leave-to {
  animation-name: sunrise;
  animation-duration: 300ms;
  animation-timing-function: ease-in;
  animation-direction: reverse;
}

@keyframes sunrise {
  0% {
    opacity: 0;
    transform: translateY(8rem) scale(0.1) rotate(-40deg);
  }
  66% {
    transform: translateY(-2rem) scale(1.15) rotate(5deg);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1) rotate(0deg);
  }
}

</style>
